import { createSlice } from '@reduxjs/toolkit'

const aboutSlice = createSlice({
    name: 'about',
    initialState: {
        aboutInfo: {}
    },
    reducers: {
        fetchAboutAction: (state, action) => {
            state.aboutInfo = action.payload
        }
    }

})

export const {fetchAboutAction} = aboutSlice.actions

export default aboutSlice